import React from 'react'
import img2 from "../Assets/img/lucc admin.PNG"
import img1 from "../Assets/img/lucc png.PNG"
import img3 from "../Assets/img/startech.PNG"

const Portfolio=()=> {

  const data=[
    {
      "project_name":"Leading university computer club  USER",
      "title":"Leading univercity user font-end site where club members are access all features",
      "img":img1,
      "clint":"0",
      "mail":"1admin181@gmail.com",
      "pass":"111111",
      "link":"https://user-fontend-lucc.netlify.app/",
    },
    {
      "project_name":"Leading university computer club ADMIN",
      "title":"Here only admin and super admin can access the site and manage the whole operational functional",
      "img":img2,
      "clint":"0",
      "mail":"rmzahudhasan181@gmail.com	",
      "pass":"111111",
      "link":"https://lucc-admin-2k21.netlify.app/",
    },
    {
      "project_name":"Star tech clone",
      "title":"Bangladesh's one of the biggest tech website , This is a clone project perpose for learning and advance development",
      "img":img3,
      "clint":"0",
      "link":"https://star-tech-clone.netlify.app/",
    }
    
  ]

  data.map(data=>{
    console.log(data)
  })
  return (

  
    <>
    
    
    <div className="main-wrapper">
      <section className="cta-section theme-bg-light py-5">
        <div className="container text-center single-col-max-width">
          <h2 className="heading">Portfolio</h2>
          <div className="intro">
            <p>
              Welcome to my online portfolio. Lorem ipsum dolor sit amet,
              consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
              I'm taking on freelance work at the moment. Want some help
              building your software?
            </p>
          </div>
          <a className="btn btn-primary" href="/contact" target="_blank">
            <i className="fas fa-paper-plane me-2" />
            Hire Me
          </a>
        </div>
        {/*//container*/}
      </section>

      <section className="projects-list px-3 py-5 p-md-5">
        
         <div className="container">
         
          <div className="text-center">
            <ul id="filters" className="filters mb-5 mx-auto   ps-0">
              <li className="type active mb-3 mb-lg-0">
                All
              </li>
              {/* <li className="type  mb-3 mb-lg-0" data-filter=".webapp">
                We App
              </li>
              <li className="type  mb-3 mb-lg-0" data-filter=".mobileapp">
                Mobile App
              </li>
              <li className="type  mb-3 mb-lg-0" data-filter=".frontend">
                Frontend
              </li>
              <li className="type  mb-3 mb-lg-0" data-filter=".backend">
                Backend
              </li> */}
            </ul>
            {/*//filters*/}
          </div>

          <div className="project-cards row isotope">
           
           



          {
            data.map(data=>
              <div className="isotope-item col-md-6 mb-5 mobileapp frontend">
              <div className="card project-card">
                <div className="row">
                  <div className="col-12 col-xl-5 card-img-holder">
                    <img
                      src={data.img}
                      className="card-img"
                      alt="image"
                    />
                  </div>
                  <div className="col-12 col-xl-7">
                    <div className="card-body">
                      <h5 className="card-title">
                        <a href="project.html" className="theme-link">
                          {/* Project Heading */}
                          {data.project_name}
                        </a>
                      </h5>
                      <p className="card-text">
                        {data.title}
                      </p>
                      
                    {
                      (data.mail && data.pass) ? <>  <p className="card-text" style={{textDecoration:'bold'}}>
                      Login Information
                     </p>
                     <p className="card-text" style={{color:"red",font:'status-bar'}}>
                       E-mail:-{data.mail}
                     </p>
                     <p className="card-text" style={{color:"red",font:'status-bar'}}>
                       Password:-{data.pass}
                     </p></>:""
                    }

                      <p className="card-text">
                        <small className="text-muted">Client: {data.clint}</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="link-mask">
                  <a className="link-mask-link" href="project.html" />
                  <div className="link-mask-text">
                    <a className="btn btn-secondary" target="_blank"  href={data.link}>
                      <i className="fas fa-eye me-2" />
                      Live demo
                    </a>
                  </div>
                </div>
                {/*//link-mask*/}
              </div>
              {/*//card*/}
            </div>
            )
          }







            {/*//col*/}
            {/* <div className="isotope-item col-md-6 mb-5 webapp frontend">
              <div className="card project-card">
                <div className="row">
                  <div className="col-12 col-xl-5 card-img-holder">
                    <img
                      src="assets/images/project/project-2.jpg"
                      className="card-img"
                      alt="image"
                    />
                  </div>
                  <div className="col-12 col-xl-7">
                    <div className="card-body">
                      <h5 className="card-title">
                        <a href="project.html" className="theme-link">
                          Project Heading
                        </a>
                      </h5>
                      <p className="card-text">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing
                        elit. Cum sociis natoque penatibus et magnis dis
                        parturient montes, nascetur ridiculus mus.{" "}
                      </p>
                      <p className="card-text">
                        <small className="text-muted">Client: Dropbox</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="link-mask">
                  <a className="link-mask-link" href="project.html" />
                  <div className="link-mask-text">
                    <a className="btn btn-secondary" href="project.html">
                      <i className="fas fa-eye me-2" />
                      View Case Study
                    </a>
                  </div>
                </div>
                
              </div>
              
            </div> */}
            {/*//col*/}
           
          </div>
          {/*//row*/}
        </div>
      </section>
      
    </div>
   
      
    
  </>



  );
}

export default Portfolio